<template>
  <div class='h-mml-lbwinbox'>
    <div class='h-mml-trunkb'>
        <div class='h-mml-trunk-searchbox'>
        <div class='h-mml-trunk-search'>
          <ejs-textbox :placeholder='SearchHoder' v-model='keywords'></ejs-textbox>
        </div>
      </div>
      <div>
        <ejs-grid ref='mmlHistoryGrid' :dataSource='historyCommandsFiltered'>
          <e-columns>
            <e-column type='checkbox' headerText='chkbox' width='72' textAlign='Center'></e-column>
            <e-column field='cmd' :headerText="this.$t('MML.command')" textAlign='Left' clipMode='EllipsisWithTooltip'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commandHistory',
  components: {
  },
  props: {
    historyCommands: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      keywords: '',
      SearchHoder: this.$t('MML.searchHolder')
    };
  },
  computed: {
    historyCommandsFiltered() {
      const trimedKeywords = this.keywords.trim();
      if(trimedKeywords === ''){ return this.historyCommands; }
      const leftHistoryCommands = this.historyCommands.filter(historyCommand =>
            this.containsKeyWords(historyCommand, trimedKeywords));
      return leftHistoryCommands;
    }
  },
  mounted() {
    // 关闭时执行一次
    console.log('----history mounted-----');
  },
  methods: {
    getCheckedRecords() {
      return this.$refs.mmlHistoryGrid.getSelectedRecords();
    },
    containsKeyWords(historyCommand, trimedKeywords) {
      return historyCommand.cmd && historyCommand.cmd.indexOf(trimedKeywords) > -1;
    },
  }
};
</script>
